// [audit fix] Email HTML is untrusted. The previous homegrown DOM walker never stripped event-handler
// attributes (onerror/onload/…) → stored XSS. Render everything through DOMPurify with email-client hardening.
import DOMPurify from 'dompurify';

// After DOMPurify's core sanitize: force safe link behaviour + block remote images (tracking pixels) by
// stashing the src on data-src so the UI can offer an explicit "Load images" action.
DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
  if (node.tagName === 'A' && node.getAttribute('href')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
  if (node.tagName === 'IMG') {
    const src = node.getAttribute('src') || '';
    if (/^https?:/i.test(src)) {
      node.setAttribute('data-src', src);
      node.removeAttribute('src');
    }
  }
});

export function sanitizeEmailHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    // DOMPurify already removes scripts, event handlers, javascript:/vbscript: URLs, and unsafe data: URIs.
    // These forbid the extras an email body should never carry.
    FORBID_TAGS: ['style', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'link', 'meta', 'base'],
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target', 'rel', 'data-src'],
    ADD_URI_SAFE_ATTR: ['data-src'],
  });
}

export function stripHtml(html: string): string {
  const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
  const tmp = document.createElement('div');
  tmp.innerHTML = clean;
  return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
}
